export default "__VITE_ASSET__CHxgEww4__"